import axios from "axios";
import Config from "./config";

import type { SyncObject } from "../types/sync_object";

class SyncObjectApi {
  static get = async (objectName: string, idToken: string) => {
    const response = await axios.get(
      `${Config.apiUrl()}/sync_objects/${objectName}`,
      {
        crossDomain: true,
        headers: {
          Authorization: idToken
        }
      }
    );
    return response.data;
  };

  static list = async (idToken: string) => {
    const response = await axios.get(`${Config.apiUrl()}/sync_objects`, {
      crossDomain: true,
      headers: {
        Authorization: idToken
      }
    });
    return response.data;
  };

  static createOrUpdate = async (syncObject: SyncObject, idToken: string) => {
    await axios({
      url: `${Config.apiUrl()}/sync_objects`,
      method: "post",
      data: syncObject,
      crossDomain: true,
      headers: {
        Authorization: idToken
      }
    });
  };

  static delete = async (objectName: string, idToken: string) => {
    await axios({
      url: `${Config.apiUrl()}/sync_objects/${objectName}`,
      method: "delete",
      crossDomain: true,
      headers: {
        Authorization: idToken
      }
    });
  };
}

export default SyncObjectApi;



// WEBPACK FOOTER //
// ./src/lib/sync_object_api.js